import * as actionTypes from '../actions/actionTypes';
import * as actions from './index';
import * as cTypes from 'config/ConfigTypes';
import { checkUser, verifyUserInputs } from 'helpers/UserHelper';

export const updateAuthObjectsSuccess = (data) => {
    return {
        type: actionTypes.AUTH_UPDATE_AUTHOBJECTS_SUCCESS,
        payload: data
    }
}

export const updateAuthObjects = (obj) => {
    return (dispatch) => {
        dispatch(actions.updateAuthObjectsSuccess(obj));
    }
}

export const setInitialState = (data) => {
    return {
        type: actionTypes.AUTH_SET_INITIAL_STATE,
        payload: data
    }
}

export const loginSuccess = (user) => {
    return {
        type: actionTypes.AUTH_LOGIN_SUCCESS,
        payload: user
    }
}

export const loginFeUser = ({ username, password }) => {
    return async (dispatch, getState) => {
        dispatch(actions.updateAuthObjects({ loading: true, loginErr: false }));
        setTimeout(async () => {
            try {
                const res = await window.flow.sdkFeReLogin(username, password);
                console.log("LOGS: login res", res);
                if (res && res.success) {
                    let user;
                    if (res.user) user = res.user;
                    else if (res.msg && res.msg.user) user = res.msg.user;
                    if (user) {
                        let fillData = checkUser({ user, getState });
                        if (fillData) {
                            dispatch(actions.updateAuthObjects({
                                loading: false, fillUser: user,
                                authForm: cTypes.FILL_USER, fillData,
                                shouldUpdate: true
                            }));
                        } else {
                            user = { metadata: { fields: { ...user } } };
                            localStorage.setItem("user", JSON.stringify(user));
                            dispatch(actions.updateAuthObjects({
                                loading: false, isLoggedIn: true, user, loginErr: false
                            }));
                        }

                    } else {
                        dispatch(actions.updateAuthObjects({ loading: false, loginErr: true }));
                    }
                } else {
                    dispatch(actions.updateAuthObjects({ loading: false, loginErr: true }));
                }
            } catch (err) {
                console.log("LOGS: Login error", err);
            }
        }, 1000);
    }
}

export const logOutFeUser = ({ cb }) => {
    return async (dispatch) => {
        try {
            const res = await window.flow.sdkFeReLogout();
            console.log("LOGS: LOGOUT logOutFeUser res", res);
            //if(res && res.success) cb();      
        } catch (err) {
            console.log("LOGS: logout error", err);
        }
    }
}

export const getInsts = () => {
    return async (dispatch) => {
        try {
            const res = await window.flow.sdkFeReGetInsts();
            if (res && res.data && res.data.insts && res.data.insts.length) {
                let instData = {};
                res.data.insts.forEach(item => {
                    if (item.id) instData[item.id] = { ...item };
                });
                if (instData) dispatch(actions.updateAuthObjects({ [cTypes.INST_DATA]: instData }));
            }
        } catch (err) {
            console.log("LOGS: getInsts err", err);
        }
    }
}

export const addUser = (userInputs) => {
    console.log("LOGS: addUser userInputs", userInputs);
    let uInputs = verifyUserInputs({ userInputs });
    console.log("LOGS: addUser uInputs", uInputs);
    return async (dispatch) => {
        try {
            const res = await window.flow.sdkFeReAddUser({ ...uInputs });
            console.log("LOGS: addUser res", res);
        } catch (err) {
            console.log("LOGS: addUser err", err);
        }
    }
}

export const saveFillData = ({ userInputs }) => {
    console.log("LOGS: saveFillData userInputs", userInputs);
    return async (dispatch) => {
        dispatch(actions.updateAuthObjects({ loading: true, status: 'saving', msg: 'Es wird bearbeitet...' }));
        setTimeout(async () => {
            try {
                const res = await window.flow.sdkFeReEditUser({ ...userInputs });
                console.log("LOGS: saveFillData res", res);
                let user;
                if (res && res.data && res.data.user) user = res.data.user;
                else if (res.msg && res.msg.user) user = res.msg.user;
                if (user) {
                    user = { metadata: { fields: { ...user } } };
                    localStorage.setItem("user", JSON.stringify(user));
                    dispatch(actions.updateAuthObjects({
                        loading: false, isLoggedIn: true, user, loginErr: false
                    }));
                    dispatch(actions.updateAuthObjects({ loading: false, status: 'updated', msg: res.msg }));
                } else {
                    dispatch(actions.updateAuthObjects({ loading: false, status: 'error', msg: res.msg }));
                }

            } catch (err) {
                dispatch(actions.updateAuthObjects({ loading: false }));
            }
        }, 1000);
    }
}

export const reqForgotPw = ({ email }) => {
    console.log("LOGS: reqForgotPw email", email);
    return async (dispatch) => {
        dispatch(actions.updateAuthObjects({ loading: true }));
        setTimeout(async () => {
            try {
                const res = await window.flow.sdkFeReForgotPassword(email);
                console.log("LOGS: reqForgotPw res", res);
                if (res) {
                    dispatch(actions.updateAuthObjects({ loading: false, status: { ...res } }));
                }
            } catch (err) {
                dispatch(actions.updateAuthObjects({ loading: false }));
            }
        }, 1000);
    }
}